var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeblack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00000;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M417.22,85.6H82.8A59.83,59.83,0,0,0,23,145.42V354.58A59.82,59.82,0,0,0,82.8,414.4H417.22A59.82,59.82,0,0,0,477,354.58V145.42A59.83,59.83,0,0,0,417.22,85.6ZM303.72,264.43l-93,46.47a16.13,16.13,0,0,1-23.36-14.41v-93a16.14,16.14,0,0,1,23.36-14.43l93,46.48A16.13,16.13,0,0,1,303.72,264.43Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeblack);
export default __webpack_public_path__ + "static/media/youtubeblack.1846b3d4101d10ae7f71c618f8f40c5f.svg";
export { ForwardRef as ReactComponent };